(() => {
  'use strict';
  const start=Date.parse('2026-10-24T17:00:00Z'),end=Date.parse('2026-10-28T16:30:00Z');
  if(Date.now()<start||Date.now()>=end)return;
  const handles=new Set(),entries=new Map();
  const selector='.ul-product-card__price,.price__container,.ul-related__price,.ul-premium__details > .money';
  const style=document.createElement('style');
  style.textContent='.ul-gpd-price-original{display:none!important}.ul-gpd-price{display:flex;flex-direction:column;align-items:flex-start;gap:5px;margin-top:8px}.ul-gpd-price__label{font:11px/1.4 Arial,sans-serif;padding:4px 8px;border-radius:4px;background:#294333;color:#fff}.ul-gpd-price strong{font-size:1.1em;color:inherit}.ul-gpd-price s{font-size:.85em;opacity:.65}.ul-gpd-price small{font:10px/1.4 Arial,sans-serif;opacity:.75}';
  document.head.append(style);
  function discounted(text){
    // Keep the displayed currency and locale; never convert from the shop base currency.
    return text.replace(/\d[\d.,\u00a0\u202f ]*\d|\d/g,token=>{
      const compact=token.replace(/[\s\u00a0\u202f]/g,'');
      const decimal=compact.match(/([.,])(\d{1,2})$/);
      const digits=decimal?compact.slice(0,-decimal[0].length).replace(/\D/g,'')+'.'+decimal[2]:compact.replace(/\D/g,'');
      const value=Number(digits);if(!Number.isFinite(value))return token;
      const precision=decimal?decimal[2].length:0;
      const locale=decimal?.[1]===','||(!decimal&&compact.includes('.'))?'id-ID':'en-US';
      return new Intl.NumberFormat(locale,{minimumFractionDigits:precision,maximumFractionDigits:precision}).format(Math.round(value*.8*10**precision)/10**precision);
    });
  }
  function handleFor(source){
    const explicit=source.closest('[data-ul-product-handle]');
    if(explicit)return explicit.dataset.ulProductHandle;
    const card=source.closest('a[href*="/products/"]')||source.closest('.product-card,.product-card-new,.ul-premium__card');
    const link=card?.matches('a')?card:card?.querySelector('a[href*="/products/"]');
    const match=link?.getAttribute('href')?.match(/\/products\/([^/?#]+)/);
    return match?decodeURIComponent(match[1]):null;
  }
  function restore(){
    for(const [source,entry] of entries){source.classList.remove('ul-gpd-price-original');entry.node.remove();}
    entries.clear();
    document.querySelectorAll('.ul-gpd-price-original').forEach(n=>n.classList.remove('ul-gpd-price-original'));
    document.querySelectorAll('[data-global-payday-price]').forEach(n=>n.remove());
  }
  function sync(){
    observer.disconnect();
    if(Date.now()<start||Date.now()>=end){restore();clearInterval(timer);return;}
    for(const [source,entry] of entries)if(!source.isConnected){entry.node.remove();entries.delete(source);}
    document.querySelectorAll(selector).forEach(source=>{
      if(source.closest('ul-global-sale-price,[data-global-payday-price],.cart-item,#CartDrawer,.cart-drawer'))return;
      if(!handles.has(handleFor(source)))return;
      const current=source.querySelector('.ul-product-card__current')||source.querySelector('[data-product-price][data-amount]')||source.querySelector('[data-product-price]')||source;
      const original=current.textContent.trim();if(!/\d/.test(original))return;
      let entry=entries.get(source);
      if(!entry){
        let node=source.nextElementSibling;
        if(!node?.hasAttribute('data-global-payday-price')){
          node=document.createElement('div');node.className='ul-gpd-price';node.setAttribute('data-global-payday-price','');
          node.innerHTML='<span class="ul-gpd-price__label">Payday Sale · 20% OFF</span><strong></strong><s></s><small>Automatically applied at checkout</small>';
          source.after(node);
        }
        entry={node,text:null};entries.set(source,entry);
      }
      if(entry.text!==original){entry.node.querySelector('strong').textContent=discounted(original);entry.node.querySelector('s').textContent=original;entry.text=original;}
      source.classList.add('ul-gpd-price-original');
    });
    observer.observe(document.body,{childList:true,subtree:true,characterData:true,attributes:true,attributeFilter:['data-amount','data-ul-product-handle']});
  }
  let queued=false,timer;
  const observer=new MutationObserver(()=>{if(!queued){queued=true;requestAnimationFrame(()=>{queued=false;sync();});}});
  async function init(){
    const root=window.Shopify?.routes?.root||'/';
    for(let page=1;;page++){
      const response=await fetch(root+'collections/maker-global/products.json?limit=250&page='+page,{credentials:'same-origin'});
      if(!response.ok)throw Error('GLOBAL collection unavailable');
      const data=await response.json();if(!Array.isArray(data.products))throw Error('Invalid collection response');
      data.products.forEach(p=>handles.add(p.handle));
      if(data.products.length<250)break;
    }
    timer=setInterval(sync,1000);sync();
    addEventListener('pageshow',sync);document.addEventListener('visibilitychange',()=>{if(!document.hidden)sync();});
  }
  init().catch(()=>{observer.disconnect();restore();});
})();
